(function () {
  document.querySelectorAll('.hl-intensity').forEach(function (root) {
    var dataEl = root.querySelector('[data-hl-levels]');
    if (!dataEl) return;
    var LEVELS;
    try {
      LEVELS = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!LEVELS.length) return;

    var level = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    var $ = function (id) {
      return root.querySelector('#' + id);
    };
    var bar = $('hl-bar');
    var pleds = root.querySelectorAll('.hl-pled');
    var glow = root.querySelector('.hl-glow');
    var minus = root.querySelector('.hl-minus');
    var plus = root.querySelector('.hl-plus');
    var els = {
      levelNum: $('hl-level-num'),
      levelName: $('hl-level-name'),
      timeNum: $('hl-time-num'),
      timeUnit: $('hl-time-unit'),
      feelword: $('hl-feelword'),
      best: $('hl-best'),
    };

    function crossfade(el, fn) {
      if (reduced) {
        fn();
        return;
      }
      el.style.transition = 'opacity .18s ease';
      el.style.opacity = '0';
      setTimeout(function () {
        fn();
        el.style.opacity = '1';
      }, 150);
    }

    function render() {
      var d = LEVELS[level];
      pleds.forEach(function (s, i) {
        s.classList.toggle('on', i <= level);
      });
      glow.style.opacity = (0.3 + level * 0.15).toFixed(2);
      els.levelNum.textContent = level + 1;
      els.levelName.textContent = d.name;
      bar.setAttribute('aria-valuenow', level + 1);
      bar.setAttribute('aria-valuetext', 'Level ' + (level + 1) + ', ' + d.name);
      crossfade(els.timeNum.parentElement, function () {
        els.timeNum.textContent = d.time;
        els.timeUnit.textContent = d.unit;
      });
      crossfade(els.feelword, function () {
        els.feelword.textContent = d.feel;
      });
      crossfade(els.best, function () {
        els.best.textContent = d.best;
      });
      minus.disabled = level === 0;
      plus.disabled = level === LEVELS.length - 1;
    }

    function setLevel(n) {
      n = Math.max(0, Math.min(LEVELS.length - 1, n));
      if (n === level) return;
      level = n;
      render();
    }

    function mark() {
      root.classList.add('hl-interacted');
    }

    minus.addEventListener('click', function () {
      mark();
      setLevel(level - 1);
    });
    plus.addEventListener('click', function () {
      mark();
      setLevel(level + 1);
    });
    bar.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowUp', 'ArrowLeft', 'ArrowDown', 'Home', 'End'].indexOf(e.key) > -1) mark();
      if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
        e.preventDefault();
        setLevel(level + 1);
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
        e.preventDefault();
        setLevel(level - 1);
      } else if (e.key === 'Home') {
        e.preventDefault();
        setLevel(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        setLevel(LEVELS.length - 1);
      }
    });

    render();
  });
})();
